module.exports = __webpack_public_path__ + "static/media/xz08_grey.4381eac4.png";